<script lang="ts">
    import { H1, Label } from "attractions";
    import Employee from "../../Models/Employee";   
    import { LATEST_PURCHASE, LATEST_PURCHASE_WITH_PAYMENT_ACTION } from "../../Stores/Purchase";
    import Currency from "../../Utils/Currency";

    let purchasesSummary;

    async function getPurchasesSummary() {
        const res = await Employee.getPurchasesSummary();
        purchasesSummary = res;
    }

    LATEST_PURCHASE.subscribe(getPurchasesSummary);
    LATEST_PURCHASE_WITH_PAYMENT_ACTION.subscribe(getPurchasesSummary);
</script>

{#if purchasesSummary}
    <section class="unpaidSummary">
        <div class="card">
            <Label small style="margin-bottom: .25rem">Wartość nieopłaconych zakupów</Label>
            <H1>{Currency.format(purchasesSummary.purchasesAmount.unpaid)}</H1>
        </div>
        <div class="card">
            <Label small style="margin-bottom: .25rem">Nieopłacone zakupy</Label>
            <H1>{purchasesSummary.purchasesCount.unpaid}</H1>
        </div>
    </section>

    <style lang="scss">
        .unpaidSummary {
            display: flex;
            
            .card {
                margin-right: 1.5rem;
            }
        }
    </style>
{/if}
